import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, layout, radius, mq, motion } = theme.custom;
    return {
        root: {
            height: layout.headerHeight,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: '0 16px 0 12px',
            backgroundColor: color.header.bg,
            color: color.header.text,
            borderBottom: `1px solid ${color.header.border}`,
            position: 'relative',
            zIndex: 100,
            [mq.sm]: { padding: '0 8px' },
        },
        left: { display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 },
        right: { display: 'flex', alignItems: 'center', gap: 4 },
        menuButton: {
            display: 'none',
            color: color.header.text,
            width: 40,
            height: 40,
            '&:hover': { backgroundColor: color.header.hover },
            [mq.sm]: { display: 'inline-flex' },
        },
        brand: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '6px 8px',
            borderRadius: radius.md,
            color: color.header.text,
            textDecoration: 'none',
            minHeight: 40,
            transitionProperty: 'background-color',
            transitionDuration: motion.fast,
            '&:hover': { backgroundColor: color.header.hover },
        },
        logo: {
            width: 32,
            height: 32,
            borderRadius: '50%',
            display: 'block',
            outline: '1px solid rgba(255, 255, 255, 0.12)',
            outlineOffset: -1,
        },
        wordmark: {
            fontSize: 15,
            fontWeight: 700,
            letterSpacing: '-0.01em',
            whiteSpace: 'nowrap',
            [mq.xs]: { display: 'none' },
        },
        product: {
            fontSize: 10,
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            padding: '2px 6px',
            borderRadius: radius.xs,
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
            color: color.header.textMuted,
            [mq.xs]: { display: 'none' },
        },
        iconButton: {
            color: color.header.textMuted,
            width: 40,
            height: 40,
            '&:hover': { backgroundColor: color.header.hover, color: color.header.text },
        },
        account: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            minHeight: 40,
            padding: '4px 8px 4px 4px',
            border: 'none',
            borderRadius: radius.md,
            backgroundColor: 'transparent',
            color: color.header.text,
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'left',
            transitionProperty: 'background-color',
            transitionDuration: motion.fast,
            '&:hover': { backgroundColor: color.header.hover },
            '&[aria-expanded="true"]': { backgroundColor: color.header.hover },
        },
        avatar: {
            width: 32,
            height: 32,
            borderRadius: '50%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.02em',
            color: '#FFFFFF',
            background: color.gradient.brand,
            flexShrink: 0,
        },
        accountText: {
            display: 'flex',
            flexDirection: 'column',
            lineHeight: 1.2,
            minWidth: 0,
            [mq.xs]: { display: 'none' },
        },
        userName: {
            fontSize: 13,
            fontWeight: 600,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 180,
        },
        userRole: {
            fontSize: 11,
            color: color.header.textMuted,
            [mq.sm]: { display: 'none' },
        },
        chevron: { color: color.header.textMuted, [mq.xs]: { display: 'none' } },
        menuHeader: { display: 'flex', flexDirection: 'column', gap: 2, padding: '8px 12px 6px', lineHeight: 1.3, backgroundColor: 'transparent' },
        menuName: { fontSize: 13, fontWeight: 600, color: color.text.primary, overflowWrap: 'anywhere' },
        menuRole: { fontSize: 12, color: color.text.secondary },
    };
});
